/* istanbul ignore file */
import fetchAllClients from '@/lib/api/fetchAllClients';
import { getAllEmployeesListCtor, axiosInstance as restInstance } from '@/lib/advisors/getAllClients';
import { getClientDataCtor } from '@/lib/advisors/getClient'; 
import { camelify } from '@/helpers/case';
import { employeeContributionsCtor, axiosInstanceCtor} from '@/lib/api/fetchEmployeeContributions';
import accounts from '@/lib/data/accounts.data';

export default {
  state: {
    clients: {
      allClients: [],
      loadingAllClients: true,
      clientDetails: {},
      loadingClientDetails: true,
      contributions: [],
    }
  },
  getters: {
    getClients({ clients }) {
      return clients;
    },
    isLoadingAllClients({ clients: { loadingAllClients } }) {
      return loadingAllClients;
    },
    allClients({ clients: { allClients } }) {
      return allClients;
    },
    isLoadingClientDetails({ clients: { loadingClientDetails } }) {
      return loadingClientDetails;
    },
    clientDetails({ clients: { clientDetails } }) {
      return clientDetails;
    },
    feeData(state) {
      if (state.clients.clientDetails && state.clients.clientDetails.incepted_accounts_exist) {
        return {
          fee_summary: state.clients.clientDetails.statement.fee_summary,
          fee_breakdown: state.clients.clientDetails.statement.fees,
        };
      }
      return null;
    },
    holdingData(state) {
      if (state.clients.clientDetails && state.clients.clientDetails.incepted_accounts_exist && state.clients.clientDetails) {
        return state.clients.clientDetails.statement.holdings;
      }
      return null;
    },
    sinceInceptionData(state) {
      if (state.clients.clientDetails && state.clients.clientDetails.incepted_accounts_exist && state.clients.clientDetails) {
        return state.clients.clientDetails.since_inception;
      }
      return null;
    },
    usdToCadExchangeRate(state) {
      if (state.clients.clientDetails && state.clients.clientDetails.incepted_accounts_exist) {
        return state.clients.clientDetails.statement.usd_to_cad_exchange_rate;
      }
      return null;
    },
    activityData(state) {
      if (state.clients.clientDetails && state.clients.clientDetails.incepted_accounts_exist) {
        return state.clients.clientDetails.statement.activity;
      }
      return null;
    },
    inceptionDate(state) {
      if (state.clients.clientDetails && state.clients.clientDetails.incepted_accounts_exist) {
        return state.clientDetails.statement.oldest_account_inception_date;
      }
      return null;
    },
    getContributions(state) {
      return state.clients.contributions || [];
    }
  },
  mutations: {
    updateClients(state, clients) {
      Object.assign(state.clients, clients);
    },
    setLoadingAllClients(state, loadingAllClients) {
      state.clients.loadingAllClients = loadingAllClients;
    },
    setLoadingClientDetails(state, loadingClientDetails) {
      state.clients.loadingClientDetails = loadingClientDetails;
    },
    updateClientDetails(state, clientDetails) {
      state.clients.clientDetails = clientDetails;
    },
    updateAllClients(state, allClients) {
      state.clients.allClients = allClients;
    },
    updateContributions(state, contributions) {
      state.clients.contributions = contributions;
    },
  },
  actions: {
    updateClients({ commit }, clients) {
      commit('updateClients', clients);
    },
    async fetchClientDetails({ commit, rootGetters }, clientId) {
      commit('setLoadingClientDetails', true);
      commit('updateClientDetails', {});
      const axiosInstance = restInstance(rootGetters?.ciToken || null);
      const getClientData = getClientDataCtor({ axiosInstance });
      try {
        let clientDetails = await getClientData(clientId); 
        commit('updateClientDetails', clientDetails);
        commit('setLoadingClientDetails', false);
        return clientDetails;
      } catch(e) {
        commit('setLoadingClientDetails', false);
        return Promise.reject(e);
      }
    },
    async fetchAllClients({ commit, rootGetters }) {
      const axiosInstance = restInstance(rootGetters?.ciToken || null);
      const getAllEmployeesList = getAllEmployeesListCtor({ axiosInstance });
      commit('setLoadingAllClients', true);
      let clients;
      try {
        if(getAllEmployeesList) {
          clients = await getAllEmployeesList();
        }
        commit('updateAllClients', camelify(clients));
        commit('setLoadingAllClients', false);
        return clients || null;
      } catch(e) {
        commit('updateAllClients', []);
        commit('setLoadingAllClients', false);
        return Promise.reject(e);
      }
    },
    async fetchContributions({ commit, rootGetters }, clientId) {
      const axiosInstance = axiosInstanceCtor(rootGetters?.ciToken || null);
      const employeeContributions = employeeContributionsCtor({ axiosInstance });
      try {
        const contributions = await employeeContributions(clientId);
        commit('updateContributions', camelify(contributions));
        return contributions || null;
      } catch(e) {
        commit('updateContributions', []);
        return Promise.reject(e);
      }
    },
    resetContrbutions({ commit }) {
      commit('updateContributions', []);
    }
  },
};
